import React, { FC, useMemo } from 'react';
import { Environment, RecordSource, Store, Network } from 'relay-runtime';
import { RelayEnvironmentProvider } from 'relay-hooks';
import { GATEWAY_URL } from 'config';
import { useAuth } from 'utils/auth';
import { fetchQueryFactory } from './network';

interface GraphQLProvider {
  environment?: Environment;
}

const GraphQLProvider: FC<GraphQLProvider> = ({
  children,
  environment,
}): JSX.Element => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth();
  const url = GATEWAY_URL;

  const relayEnvironment = useMemo(() => {
    const getToken = isAuthenticated
      ? getAccessTokenSilently
      : () => new Promise(resolve => resolve(''));
    return (
      environment ||
      new Environment({
        network: Network.create(
          fetchQueryFactory({ getAccessToken: getToken, url })
        ),
        store: new Store(new RecordSource()),
      })
    );
  }, [environment, getAccessTokenSilently, isAuthenticated, url]);

  return (
    <RelayEnvironmentProvider environment={relayEnvironment}>
      {children}
    </RelayEnvironmentProvider>
  );
};

export default GraphQLProvider;
